import React from "react";
// import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

import Button from "../Button";
import Jumbotron from "../Jumbotron";
import Text from "../Text";

import "./animate.css";

interface Props {
  heading: string;
  role: string;
  context: string;
  Available: string;
  tagList: string[];
  alt: string;
  img: string;
  imgHeight?: string;
  imgWidht?: string;
  justifyContent?: string;
}

const CardWithImage: React.FC<Props> = ({
  heading,
  role,
  context,
  Available,
  tagList,
  alt,
  imgHeight,
  imgWidht,
  img,
  justifyContent = "flex-start",
}) => (
  <Jumbotron
    flexDirection="row"
    justifyContent={justifyContent}
    textAlign="left"
    width="100%"
    margin="20px 0"
  >
    <Jumbotron
      flexDirection="column"
      padding="10px"
      justifyContent="flex-start"
      width="100%"
      margin="0px"
    >
      <Text text={heading} fs="26px" fontWeight="700" />
      <Text text={role} fs="16px" margin="5px 0" fontWeight="200" />
      <Text text={context} margin="5px 0" fs="16px" fontWeight="200" />
      <Text text={Available} fs="16px" margin="5px 0" fontWeight="200" />
      <Jumbotron justifyContent="flex-start" width="100%">
        {tagList &&
          tagList.map((tag) => (
            <Button
              bg="gray"
              key={heading + tag}
              fontSize="11px"
              margin="5px 10px"
              padding="2px 5px"
              text={tag}
              height="20px"
              handleOnClick={() => console.log("Now Smile")}
            />
          ))}
      </Jumbotron>
    </Jumbotron>

    <Jumbotron
      justifyContent="flex-start"
      width="70%"
      margin="5px"
      flexGrow="1"
      minWidth="300px"
    >
      <ScrollAnimation animateIn="fadeInRight" delay={100} offset={250}>
        <img src={img} alt={alt} width={imgWidht} height={imgHeight} />
      </ScrollAnimation>
    </Jumbotron>
  </Jumbotron>
);

export default CardWithImage;
